import React, {useState} from "react";
import ReportsTab from "../../../component/dashboard/AllTabs/FirstTab";
import YourStatsTab from "../../../component/dashboard/AllTabs/SecondTab";
import PrescriptionTab from "../../../component/dashboard/AllTabs/PrescriptionTab";
import TabNavItem from "../../../component/dashboard/TabNavItem";
import TabContent from "../../../component/dashboard/TabContent";
const Tabs = () => {
  const [activeTab, setActiveTab] = useState("reports");
  const handleReports = () => {
    setActiveTab("reports");
  };
  const handleYourStats = () => {
    setActiveTab("your_stats");
  };
  const handlePrescription = () => {
    setActiveTab("prescription");
  };
  return (
    <div className="Tabs">
      {/* Tab nav */}
      <ul className="nav">
        <TabNavItem title="Reports" id="reports" activeTab={activeTab} setActiveTab={setActiveTab}/>
        <TabNavItem title="Your Stats" id="your_stats" activeTab={activeTab} setActiveTab={setActiveTab}/>
        <TabNavItem title="Prescription" id="prescription" activeTab={activeTab} setActiveTab={setActiveTab}/>
      </ul>
      <div className="outlet">
        <TabContent id="reports" activeTab={activeTab}>
          <ReportsTab/>
        </TabContent>
        <TabContent id="your_stats" activeTab={activeTab}>
          <YourStatsTab/>
        </TabContent>
        <TabContent id="prescription" activeTab={activeTab}>
          <PrescriptionTab/>
        </TabContent>
      </div>
    </div>
  );
};
export default Tabs;


// WEBPACK FOOTER //
// ./src/component/dashboard/TabComponent/Tabs.js